<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise = !minimise"></i>
    <i class="fa fa-times" (click)="cancel()"></i>
  </div>
</div>

<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="selectTab(tab.id)" class="btn-sm">{{ tab.name }}</a>
    </li>
}
  </ul>

  <div class="tab-content">
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
    </div>
}

    @if (!showFormLoader) {

      @if (formHeader && formHeader.length) {
<h3 class="col-md-12 text-center">
        <b>{{ formHeader[0].ATTRIB_DESCRIPTION }}</b>
      </h3>
}

      @if (activeTab === 'cash_flow') {

        <ng-container *ngTemplateOutlet="cashFlowTable"></ng-container>
      
} @else {

        <ng-container *ngTemplateOutlet="multiColTable"></ng-container>
      
}
      

      @if ((!formHeader || !formHeader.length) && (!tableRows || !tableRows.length)) {
<p>
        No form data available.
      </p>
}
    
}
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button" type="button" [disabled]="crudLoading" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>

<!-- ──────── Multi-column schedule table (TI / FSI / OI / GBF) ──────── -->
<ng-template #multiColTable>
  <div>
    <table class="table table-no-border form-inline">
      <thead>
        <tr>
          @if (tableHeader && tableHeader.length) {
<th>{{ tableHeader[0].DESCRIPTION }}</th>
}
          @for (val of tableHeader; track $index) {
<th>{{ val.ATTRIB_DESCRIPTION }}</th>
}
        </tr>
      </thead>
      <tbody>
        @for (row of tableRows; track trackByIndex($index)) {
<tr>
          <!-- Description column (driven by row[0]) -->
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'PH') {
<td
              style="border-top-width: 0; width: 30%; font-size: 18px; font-weight: bold;">
            {{ row[0].DESCRIPTION }}
          </td>
}
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'DT') {
<td
              style="border-top-width: 0; width: 30%;">
            {{ row[0].DESCRIPTION }}
          </td>
}
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'AGG') {
<td
              style="border-top-width: 0; width: 30%; background-color: whitesmoke; font-weight: bold;">
            {{ row[0].DESCRIPTION }}
          </td>
}

          <!-- Prior Submission (row[0] value) -->
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'PH') {
<td
              style="border-top-width: 0; font-weight: bold;">
            {{ row[0].ATTRIB_VALUE }}
          </td>
}
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'DT') {
<td
              style="border-top-width: 0;">
            <table border="0"><tr><td align="right" style="width: 38%"
                [ngClass]="{'color-red': row[0].ATTRIB_VALUE < 0}">
                {{ row[0].ATTRIB_VALUE | numberWithCommas }}
              </td><td></td></tr></table>
          </td>
}
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'AGG') {
<td
              style="border-top-width: 0; background-color: whitesmoke; font-weight: bold;">
            <table><tr><td align="right" style="width: 38%"
                [ngClass]="{'color-red': row[0].ATTRIB_VALUE < 0}">
                {{ row[0].ATTRIB_VALUE | numberWithCommas }}
              </td><td></td></tr></table>
          </td>
}

          <!-- Current Submission (row[1]) -->
          @if (row[1]?.IS_FORM_DISPLAY == 'Y' && row[1]?.ROW_TYPE == 'PH') {
<td
              style="border-top-width: 0; font-weight: bold;">
            {{ row[1].ATTRIB_VALUE }}
          </td>
}
          @if (row[1]?.IS_FORM_DISPLAY == 'Y' && row[1]?.ROW_TYPE == 'DT') {
<td
              style="border-top-width: 0;">
            <input type="text"
                   class="form-control input-sm numText"
                   style="text-align: right; width: 120px;"
                   [disabled]="row[1].IS_EDITABLE_CELL == 'N'"
                   [(ngModel)]="row[1].ATTRIB_VALUE"
                   [ngModelOptions]="{ standalone: true }"
                   (ngModelChange)="applyFormula(row[1])" />
          </td>
}
          @if (row[1]?.IS_FORM_DISPLAY == 'Y' && row[1]?.ROW_TYPE == 'AGG') {
<td
              style="border-top-width: 0; background-color: whitesmoke; font-weight: bold;">
            <table><tr><td align="right" style="width: 33%"
                [ngClass]="{'color-red': row[1].ATTRIB_VALUE < 0}">
                {{ row[1].ATTRIB_VALUE | numberWithCommas }}
              </td><td></td></tr></table>
          </td>
}

          <!-- Variance (row[2]) -->
          @if (row[2]?.IS_FORM_DISPLAY == 'Y' && row[2]?.ROW_TYPE == 'PH') {
<td
              style="border-top-width: 0; font-weight: bold;">
            {{ row[2].ATTRIB_VALUE }}
          </td>
}
          @if (row[2]?.IS_FORM_DISPLAY == 'Y' && row[2]?.ROW_TYPE == 'DT') {
<td
              style="border-top-width: 0;">
            <table><tr><td align="right" style="width: 38%"
                [ngClass]="{'color-red': row[2].ATTRIB_VALUE < 0}">
                {{ row[2].ATTRIB_VALUE | numberWithCommas }}
              </td><td></td></tr></table>
          </td>
}
          @if (row[2]?.IS_FORM_DISPLAY == 'Y' && row[2]?.ROW_TYPE == 'AGG') {
<td
              style="border-top-width: 0; background-color: whitesmoke; font-weight: bold;">
            <table><tr><td align="right" style="width: 38%"
                [ngClass]="{'color-red': row[2].ATTRIB_VALUE < 0}">
                {{ row[2].ATTRIB_VALUE | numberWithCommas }}
              </td><td></td></tr></table>
          </td>
}

          <!-- Explanation (row[3]) -->
          @if (row[3]?.IS_FORM_DISPLAY == 'Y' && row[3]?.ROW_TYPE == 'PH') {
<td
              style="border-top-width: 0; font-weight: bold;">
            {{ row[3].ATTRIB_VALUE }}
          </td>
}
          @if (row[3]?.IS_FORM_DISPLAY == 'Y' && row[3]?.ROW_TYPE == 'DT') {
<td
              style="border-top-width: 0;">
            {{ row[3].ATTRIB_VALUE }}
          </td>
}
          @if (row[3]?.IS_FORM_DISPLAY == 'Y' && row[3]?.ROW_TYPE == 'AGG') {
<td
              style="border-top-width: 0; background-color: whitesmoke;">
            <textarea class="form-control input-sm"
                      style="width: 100%;"
                      [(ngModel)]="row[3].ATTRIB_VALUE"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="markChange(row[3])"></textarea>
          </td>
}
        </tr>
}
      </tbody>
    </table>
  </div>
</ng-template>

<!-- ──────── Cash Flow table (single Current Submission column) ──────── -->
<ng-template #cashFlowTable>
  <div>
    <table class="table table-no-border form-inline">
      <thead>
        <tr>
          @if (tableHeader && tableHeader.length) {
<th>{{ tableHeader[0].DESCRIPTION }}</th>
}
          @for (val of tableHeader; track $index) {
<th width="50%">{{ val.ATTRIB_DESCRIPTION }}</th>
}
        </tr>
      </thead>
      <tbody>
        @for (row of tableRows; track trackByIndex($index)) {
<tr>
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'PH') {
<td
              style="border-top-width: 0; width: 30%; font-size: 18px; font-weight: bold;">
            {{ row[0].DESCRIPTION }}
          </td>
}
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'DT') {
<td
              style="border-top-width: 0; width: 30%;">
            {{ row[0].DESCRIPTION }}
          </td>
}
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'AGG') {
<td
              style="border-top-width: 0; width: 30%; background-color: whitesmoke; font-weight: bold;">
            {{ row[0].DESCRIPTION }}
          </td>
}

          <!-- PH header value -->
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'PH') {
<td
              style="border-top-width: 0; font-weight: bold;">
            {{ row[0].ATTRIB_VALUE }}
          </td>
}

          <!-- DT editable -->
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'DT' && row[0]?.IS_EDITABLE == 'Y') {
<td
              style="border-top-width: 0;">
            <input type="text"
                   class="form-control input-sm numText"
                   style="text-align: right; width: 120px;"
                   [disabled]="row[0].IS_EDITABLE_CELL == 'N'"
                   [(ngModel)]="row[0].ATTRIB_VALUE"
                   [ngModelOptions]="{ standalone: true }"
                   (ngModelChange)="applyFormula(row[0])" />
          </td>
}

          <!-- DT read-only -->
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'DT' && row[0]?.IS_EDITABLE == 'N') {
<td
              style="border-top-width: 0;"
              [ngClass]="{'color-red': row[0].ATTRIB_VALUE < 0}">
            <table><tr><td align="right" width="9.5%">{{ row[0].ATTRIB_VALUE | numberWithCommas }}</td><td width="90.5%"></td></tr></table>
          </td>
}

          <!-- AGG aggregate row -->
          @if (row[0]?.IS_FORM_DISPLAY == 'Y' && row[0]?.ROW_TYPE == 'AGG') {
<td
              style="border-top-width: 0; background-color: whitesmoke; font-weight: bold;"
              [ngClass]="{'color-red': row[0].ATTRIB_VALUE < 0}">
            <table><tr><td align="right" width="9.5%">{{ row[0].ATTRIB_VALUE | numberWithCommas }}</td><td width="90.5%"></td></tr></table>
          </td>
}
        </tr>
}
      </tbody>
    </table>
  </div>
</ng-template>
